import PredictiveSearch from "@shopify/theme-predictive-search";

const selectors = {
  resultsBody: '.drw-Drawer_Search__Results'
}

export default function init ({ el, context }) {
  const nodeSelectors = {
    resultsBody: document.querySelector(selectors.resultsBody)
  };

  var predictiveSearch = new PredictiveSearch({
    resources: {
      type: [PredictiveSearch.TYPES.PRODUCT],
      limit: 10,
      options: {
        unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
        fields: [
          PredictiveSearch.FIELDS.TITLE,
          PredictiveSearch.FIELDS.VENDOR,
          PredictiveSearch.FIELDS.PRODUCT_TYPE,
          PredictiveSearch.FIELDS.VARIANTS_TITLE
        ]
      }
    }
  });

  predictiveSearch.on("success", suggestions => {
    const productSuggestions = suggestions.resources.results.products;
    debugger
    if (productSuggestions.length > 0) {
      nodeSelectors.resultsBody.innerHTML = ""
      for (var i = productSuggestions.length - 1; i >= 0; i--) {
        nodeSelectors.resultsBody.innerHTML = nodeSelectors.resultsBody.innerHTML + `<div class="menu-search-product">${productSuggestions[i].title}</div>`
      } 
    }
  });

  const searchForm = el.querySelector('form')
  var input = searchForm.querySelector('input')
  
  input.addEventListener("keyup", event => {
    
    if(nodeSelectors.resultsBody.getAttribute('aria-hidden') === "true"){
      nodeSelectors.resultsBody.setAttribute('aria-hidden', false);
    }
    
    if(event.currentTarget.value.length > 3){
      debugger
      predictiveSearch.query(event.currentTarget.value);
    }
  })
}